// Generated by CoffeeScript 1.12.6
var sites;

require('angular-resource');

sites = require('goodeggs-sites');

module.exports = __filename;

angular.module(__filename, ['ngResource']).factory('ProductType', [
  '$resource', '$window', function($resource, $window) {
    return $resource((sites.getUrl('kale', $window.settings)) + "/api/proxy/api.goodeggs/product-types", null, {
      getAll: {
        method: 'GET',
        isArray: true
      }
    });
  }
]);
